module.exports = {
	title: 'Social Bar',
	status: 'wip',
	notes: 'Section for sharing articles to Facebook, Twitter and, LinkedIn',
	context: {
		items: [
			{
				link: 'https://www.facebook.com/dialog/share?app_id=404072160034196&display=popup&href=[urlencode(URL_TO_THIS_PAGE)]&redirect_uri=[urlencode(URL_TO_THIS_PAGE)]',
				icon: 'icon-facebook',
				width: '20px',
				height: '20px',
				label: 'Facebook'
			},
			{
				link: 'https://twitter.com/share?url=[urlencode(URL_TO_THIS_PAGE)]&via=fmv_sverige',
				icon: 'icon-twitter',
				width: '20px',
				height: '20px',
				label: 'Twitter'
			},
			{
				link: 'https://www.linkedin.com/shareArticle?mini=true&url=[urlencode(URL_TO_THIS_PAGE)]?fmv',
				icon: 'icon-linkedin',
				width: '20px',
				height: '20px',
				label: 'LinkedIn'
			},
		],
	},
};